import dayjs from 'dayjs';

import { isJson } from '@utils/JsonUtils';

export interface ProfilePublicUser {
  otp_verified: boolean;
  verified_date: Date;
}

const PUBLIC_PROFILE_OTP_CACHE_MINUTES = 30;

export const isPublicUserOtpCacheValid = (userData: ProfilePublicUser | null | undefined): boolean => {
  if (!userData?.otp_verified || !userData.verified_date) {
    return false;
  }
  return dayjs().diff(dayjs(userData.verified_date), 'minute') <= PUBLIC_PROFILE_OTP_CACHE_MINUTES;
};

export const getAnonymousViewerId = (): string | null => {
  return localStorage.getItem('anonymousViewerId') || null;
};

export const setAnonymousViewerId = (viewerId: string, forceUpdate?: boolean): string | null => {
  let anonymousViewerId = getAnonymousViewerId();
  if (!anonymousViewerId || forceUpdate) {
    anonymousViewerId = viewerId;
    localStorage.setItem('anonymousViewerId', anonymousViewerId);
  }
  return anonymousViewerId;
};

export const getPublicUserData = (profileId: string, userName: string): ProfilePublicUser | null => {
  const publicProfileUserDataStr = localStorage.getItem('publicProfileUserData');
  if (publicProfileUserDataStr && isJson(publicProfileUserDataStr)) {
    const publicProfileUserData = JSON.parse(publicProfileUserDataStr);
    if (publicProfileUserData && publicProfileUserData[profileId]) {
      const userData: Record<string, ProfilePublicUser> = publicProfileUserData[profileId];
      return userData ? userData[userName] : null;
    }
  }
  return null;
};

export const setPublicUserData = (profileId: string, userName: string, data: ProfilePublicUser): void => {
  const publicProfileUserDataStr = localStorage.getItem('publicProfileUserData');
  const publicProfileUserData = publicProfileUserDataStr && isJson(publicProfileUserDataStr) ? JSON.parse(publicProfileUserDataStr) : {};
  if (!publicProfileUserData[profileId]) {
    publicProfileUserData[profileId] = {};
  }
  publicProfileUserData[profileId][userName] = data;
  localStorage.setItem('publicProfileUserData', JSON.stringify(publicProfileUserData));
};

export const deletePublicUserData = (profileId: string, userName: string): void => {
  const publicProfileUserDataStr = localStorage.getItem('publicProfileUserData');
  const publicProfileUserData = publicProfileUserDataStr && isJson(publicProfileUserDataStr) ? JSON.parse(publicProfileUserDataStr) : {};
  if (publicProfileUserData[profileId]) {
    delete publicProfileUserData[profileId][userName];
  }
  localStorage.setItem('publicProfileUserData', JSON.stringify(publicProfileUserData));
};
